import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const [{ record_id, isManagingRecord }] = hooks.useFormState()
  const navigate = hooks.useNavigate()

  const enableSubmitAll = !!isManagingRecord

  const mergedProps = {
    navigate,
    record_id,
    enableSubmitAll
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
